import {
  CLEAR_SANTA_ERROR,
  FETCH_SANTA_AVAILABLE_TIMESLOTS,
  ON_SANTA_PAGE_LOADED,
  SET_SANTA_TIMESLOT_TIMEZONE,
  SUBMIT_SANTA_SIGNUP_FORM
} from 'store/ducks/santa/types';

export const reserveSantaTimeslot = (date, time, timeInCustomerLocation) => ({ type: SUBMIT_SANTA_SIGNUP_FORM, date, time, timeInCustomerLocation });
export const fetchSantaAvailableTimeslots = () => ({ type: FETCH_SANTA_AVAILABLE_TIMESLOTS });
export const setTimeslotTimezone = timezone => ({ type: SET_SANTA_TIMESLOT_TIMEZONE, timezone });
export const onSantaPageLoaded = () => ({ type: ON_SANTA_PAGE_LOADED });
export const clearSantaError = () => ({ type: CLEAR_SANTA_ERROR });
